import React, { Component } from 'react';
import LoaderFabric from './loaderfabric';

class Spinner extends Component {

    render() {
        const spinner = this.props.visible ? <LoaderFabric overlay={this.props.overlay} /> : null;

        return (
            <>
                {spinner}
            </>
        );
    }
}

export default Spinner;